import React, { useContext, useEffect, useState } from 'react'

import { PAGE_TITLE } from '../../Configuration'
import Accordions from '../../components/accordions/accordions'
import usePageTitle from '../../hooks/use-page-title'
import useReleaseNotes from '../../hooks/use-release-notes'
import PageHeader from '../../layouts/header/page-header'
import { PreviousPageContext } from '../../store/previous-page-provider'
import NO_RESULTS from '../../utils/constants/no-results'
import './releasenotes.css'
import ReleaseVersions from './releasenotes-data'

interface ReleaseNote {
  IsArchived: boolean
  KnownIssues: string
  NewFeatures: string
  ResolvedIssues: string
  eKey?: string
  eTag?: string
  titlename: string
}

function ReleaseNotes() {
  const { releaseNotes } = useReleaseNotes({
    isArchived: false,
    orderBy: 'ItemCreated',
  })
  usePageTitle(PAGE_TITLE.RELEASE_NOTES)
  const { currentPage, setCurrentPage, setPreviousPage } = useContext(PreviousPageContext)
  const [releaseNoteItems, setReleaseNoteItems] = useState<ReleaseNote[]>([])

  useEffect(() => {
    async function getReleaseNotes() {
      if (releaseNotes.length > 0) {
        const releaseNote =
          releaseNotes?.map((rn, ind) => ({
            Id: ind + 1,
            IsArchived: rn.IsArchived,
            KnownIssues: rn.KnownIssues ? rn.KnownIssues : '',
            NewFeatures: rn.KnownIssues ? rn.KnownIssues : '',
            ResolvedIssues: rn.ResolvedIssues ? rn.ResolvedIssues : '',
            content: (
              <ul>
                <ReleaseVersions
                  KnownIssues={rn.KnownIssues ? rn.KnownIssues : ''}
                  NewFeatures={rn.NewFeatures ? rn.NewFeatures : ''}
                  ResolvedIssues={rn.ResolvedIssues ? rn.ResolvedIssues : ''}
                />
              </ul>
            ),
            title: (
              <>
                <span>{rn.VersionName}</span>
                <sup>th</sup>
              </>
            ),
            titlename: rn.VersionName,
          })) || []
        setReleaseNoteItems(releaseNote)
      }
    }
    getReleaseNotes()
  }, [releaseNotes])

  useEffect(() => {
    // This effect runs whenever the location changes (when the user navigates to a different route)
    if (currentPage !== location.pathname) {
      // User has navigated to a new page, so update the previous page
      setPreviousPage(currentPage) // Store the previous page
      setCurrentPage(location.pathname) // Update the current page
    }
  }, [location, currentPage]) // Runs whenever location or currentPage changes

  return (
    <>
      <PageHeader icon='icon-Checklisticon pe-1 color-primary font-16' name='Release Notes' />
      <div className='card-body m-2 shadow1 whitebg'>
        {releaseNoteItems.length > 0 ? (
          <Accordions
            accordionitemclass='border-bottom1'
            className='accordions releasenoteaccordions'
            inputProps={{
              className: 'justify-content-start title-color12 px-0 mx-0',
              contentclassName: 'p-0 px-3',
            }}
            items={releaseNoteItems}
            titleIcon='icon-right-arrow color-primary rotate90  p-2'
            titlecollapsedIcon='icon-right-arrow color-primary p-2 '
          />
        ) : (
          <NO_RESULTS />
        )}
      </div>
    </>
  )
}

export default ReleaseNotes
